import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface ConfirmDialogProps {
  title: string;
  description?: string;
  // verbo da ação ("Excluir", "Inativar"), no lugar de um "Sim" genérico
  confirmLabel?: string;
  cancelLabel?: string;
  // ação que remove ou desativa algo: o botão de confirmar fica vermelho
  destructive?: boolean;
  handleNoClick(): void;
  handleYesClick(): void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  destructive = false,
  handleNoClick,
  handleYesClick,
}) => {
  return (
    <Dialog open maxWidth="xs" fullWidth onClose={handleNoClick}>
      <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>{title}</DialogTitle>
      {description && (
        <DialogContent>
          <DialogContentText variant="body2">{description}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" color="inherit" onClick={handleNoClick}>
          {cancelLabel}
        </Button>
        <Button variant="contained" color={destructive ? 'error' : 'primary'} autoFocus onClick={handleYesClick}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
